<template>
    <div>
        <div class="item-info">
            <div>
                <div class="item-info-title">
                    项目名称：
                </div>
                <div class="item-info-value">
                    {{ itemInfo.name }}
                </div>
            </div>
            <div style="margin-top: 5px">
                <div class="item-info-title">
                    项目备注：
                </div>
                <div class="item-info-value">
                    {{ itemInfo.remark }}
                </div>
            </div>
        </div>
        <Row style="margin-top: 10px">
            <Col span="10">
                <div class="select-user-title">
                    <span>选择人员</span>
                </div>
                <div class="select-user-tree">
                    <Tree :data="treeNodes" show-checkbox expand-node @on-check-change="onTreeChange"></Tree>
                </div>
            </Col>
            <Col span="14">
                <div class="select-user-title" style="margin-right: 0">
                    <span>已选人员</span>
                </div>
                <div class="select-user-tree" style="margin-right: 0">
                    <div style="text-align: center;margin-top: 20px">点击确定后，该项目将指派给如下员工来实施：</div>
                    <Row style="margin-top: 20px">
                        <Col span="8" v-for="user in selectedUserList" :key="user.id" style="text-align: center;margin-top: 10px">
                            <div class="work-name">{{ user.name }}：</div>
                            <div class="workload">
                                <Input type="number" v-model="user.workload" @on-keydown="workloadInputKeyDown"/>
                            </div>
                            <div class="work-percent">%</div>
                        </Col>
                    </Row>
                    <Row style="margin-top: 20px" v-if="selectedUserList.length > 1">
                        <Col span="8" style="text-align: center;margin-top: 10px">
                            <span class="button-setting-workload" @click="setWorkLoad">均分工作量</span>
                            <div class="workload"></div>
                            <div style="display: inline-block;width: 32px"></div>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
        <div style="text-align: right;margin-top: 10px">
            <Button style="margin-right: 10px" type="primary" @click="dispatchWorkOk" icon="md-checkmark">确定</Button>
            <Button @click="dispatchWorkCancel" icon="ios-undo">取消</Button>
        </div>
    </div>
</template>

<script>
import {queryUserWithGroup} from "@/api"

export default {
    name: "DispatchWork",
    props: {
        itemInfo: {
            type: Object,
        },
    },
    data() {
        return {
            selectedUserList: [],
            treeNodes: [],
            selectedNodes: [],
            storeInfo: {},
        }
    },
    mounted() {
        this.initInfo()
    },
    methods: {
        initInfo() {
            if (this.itemInfo.userInfoList) {
                this.selectedUserList = this.itemInfo.userInfoList
            }
            this.storeInfo = JSON.parse(sessionStorage.getItem('storeInfo'))
            let rootNode = {
                title: this.storeInfo.name,
                nodeType: 'root',
                expand: true,
                children: [],
            }
            this.treeNodes.push(rootNode)
            queryUserWithGroup().then((res) => {
                let userList = res.data
                for (let item of userList) {
                    if (!item.groupId) {
                        item.title = item.name
                        item.nodeType = 'user'
                        item.checked = this.isExist(this.itemInfo.userInfoList, item)
                        rootNode.children.push(item)
                        continue
                    }
                    let group = this.existTreeGroup(rootNode.children, item.groupId)
                    if (group == null) {
                        group = {
                            title: item.groupName,
                            nodeType: 'group',
                            expand: false,
                            children: [],
                        }
                        rootNode.children.push(group)
                        item.title = item.name
                        item.nodeType = 'user'
                        item.checked = this.isExist(this.itemInfo.userInfoList, item)
                        group.children.push(item)
                    } else {
                        item.title = item.name
                        item.nodeType = 'user'
                        item.checked = this.isExist(this.itemInfo.userInfoList, item)
                        group.children.push(item)
                    }
                }
            })
        },
        isExist(list, node) {
            if (!list) {
                return false
            }
            for (let item of list) {
                if (item.id === node.id) {
                    return true
                }
            }
            return false
        },
        onTreeChange(selectedNodes) {
            this.selectedUserList = []
            for (let item of selectedNodes) {
                this.addToSelectedUser(item)
            }
            if (this.selectedUserList.length === 1) {
                this.selectedUserList[0].workload = 100
            }
            this.$forceUpdate()
        },
        addToSelectedUser(node) {
            if (node.nodeType === 'user') {
                this.selectedUserList.push(node)
                if (node.children) {
                    for (let child of node.children) {
                        this.addToSelectedUser(child)
                    }
                }
            }
        },
        existTreeGroup(list, id) {
            for (let item of list) {
                if (item.id === id) {
                    return item
                }
            }
            return null
        },
        dispatchWorkOk() {
            this.$emit('handleClose', this.selectedUserList)
        },
        dispatchWorkCancel() {
            this.$emit('handleClose', false)
        },
        workloadInputKeyDown(event) {
            let currentValue = event.target.value
            const value = event.key
            const alwaysAllowedKeys = ["Backspace", "Tab", "Enter"]
            if (alwaysAllowedKeys.includes(value)) {
                return
            }
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault()
                return
            }
            const num = parseInt(`${currentValue}${value}`, 10)
            if (num < 0 || num > 1000) {
                event.preventDefault()
            }
        },
        setWorkLoad() {
            if (this.selectedUserList.length > 0) {
                const workload = Number(100 / this.selectedUserList.length).toFixed(0)
                for (let item of this.selectedUserList) {
                    item.workload = workload
                }
                this.$forceUpdate()
            }
        },
    },
}
</script>

<style scoped>
.item-info {
    border: 1px solid #e3e3e3;
    background: #f3f7fd;
    padding: 20px 30px;
}

.item-info-title {
    display: inline-block;
    font-weight: bold;
    width: 80px;
}

.item-info-value {
    display: inline-block;
}

.select-user-title {
    border: 1px solid #e3e3e3;
    border-left: 2px solid #2d8cf0;
    padding: 5px 10px;
    margin-right: 10px;
    background: #f3f7fd;
}

.select-user-tree {
    border: 1px solid #e3e3e3;
    border-top: none;
    margin-right: 10px;
    padding: 5px 10px;
    height: 400px;
    overflow-y: auto;
}

.work-name {
    display: inline-block;
    margin-right: 10px;
    width: 100px;
    text-align: right;
}

.workload {
    display: inline-block;
    width: 80px;
}

.work-percent {
    display: inline-block;
    background: #f3f7fd;
    border: 1px solid #e3e3e3;
    height: 32px;
    line-height: 32px;
    vertical-align: top;
    width: 32px;
    text-align: center;
}

.button-setting-workload {
    color: #2d8cf0;
    cursor: pointer;
    display: inline-block;
    width: 100px;
}
</style>
